module.exports = __webpack_public_path__ + "img/zshi.fdff1627.png";